<template>
	<v-sheet color="transparent"  id="assessment-wrapper">
		<AssessmentToolbar :question="current_question" :response="response"></AssessmentToolbar>

		<v-row ref="wrapper" >
			<v-col v-if="section"  ref="survey_container">
				<v-card class="pa-3" flat color="transparent">
					<CnRenderSurvey v-if="response" :surveyContent="survey" :response="response" v-on:viewing="(q) => {current_question = q }"></CnRenderSurvey>	
				</v-card>		
			</v-col>
		</v-row>
	</v-sheet>
</template>

<style lang="less">
	#assessment-wrapper{
	}
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import CnRenderSurvey from "@/components/survey/CnRenderSurvey"
	import AssessmentToolbar from "@/components/assessment/AssessmentToolbar"
	export default {
		name: "Assessment", 
		props: {
				
		},
		data: () => {
			return {
				width: 1000,
				status: null, 
				current_question: null
			}
		},
		components: {
			AssessmentToolbar,
			CnRenderSurvey
		},
		computed: {
			...Vuex.mapState({
				user: state => state.user,
				assessments: state => state.assessments || [],
				settings: state => state.assessmentSettings || {parts: []}, 
				surveys: state => state.surveys || [], 
			}),
			now(){
				return this.$store.getters.getDate;
			},
			assessment(){
				return this.assessments[0]
			},
			part(){
				var settings = this.settings;
				if( settings.parts ){
					return this.settings.parts[this.assessment.current_part];
				}
				return false;
			},
			section(){
				if( !this.part ){
					return false;
				}
				return this.part.sections[this.assessment.current_section];
			},
			survey(){
				if( !this.section ){
					return false;
				}
				var id = this.section.survey
				return this.surveys.find( a => a.id == id ) 
			}, 
			response(){
				if( !this.survey ){
					return null 
				}
				var part = this.assessment.current_part;
				var section = this.assessment.current_section;
				return this.assessment.responses.find( r => {
					return r.part == part && r.section == section
				}) || false
			}
		},
		methods: {
			newResponse(){
				var response = {
					id: this.generateId(),
					created: this.now,
					user: this.user.id, 
					data: {},
					part: this.assessment.current_part,
					section: this.assessment.current_section,
					completion_rate: 0, 
					survey: this.survey.id,
					status: "in_progress"
				}
				this.$store.dispatch( "assessments/newResponse", response)
			}
		},
		watch: {

			response: {
				immediate: true,
				handler(){					
					if( false == this.response ){
						this.newResponse();
					}
				}
			},
			settings: {
				deep: true,
				immediate: true,
				handler(newValue, oldValue ){
					this.status = "unsaved";
					if( newValue && !oldValue ){
						if( this.$store.hasModule("assessmentSettings")  ){
							this.$store.dispatch("assessmentSettings/getSettings").then( ( ) => {
							})
						}
						if( this.$store.hasModule("surveys")  ){
							this.$store.dispatch("surveys/getAll").then( ( ) => {
							})
						}
					}
					
				}
			}
		},
		created(){
		}

	}
</script>